export default __webpack_public_path__ + "static/media/406.bb6fd4cb.png";